module.exports = __webpack_public_path__ + "img/credit-one-club-inspiration-2.19ea6ea2.jpg";